// extracted by mini-css-extract-plugin
export var backdrop = "Search-module--backdrop--78992";
export var searchDialog = "Search-module--search-dialog--ce409";
export var searchInput = "Search-module--search-input--96b26";
export var searchResult = "Search-module--search-result--1171e";
export var searchResultButton = "Search-module--search-result-button--98d7f";
export var searchResults = "Search-module--search-results--4b3b5";